// extracted by css-extract-rspack-plugin
export default {"OmnibarContainer":"omnibar-container-module__OmnibarContainer__BF3wp"};